<template>
    <vs-table :data="data" > <!-- maxHeight="60vh" -->
      <template slot="header" >
        <vs-row style="display:inline">
          

            <vs-col vs-offset="9" vs-w="3" style="display:inline-flex">
             <div class="con-input-search vs-table--search">
                <input
                  class="input-search vs-table--search-input"
                  type="text"
                  v-model="text"
                  @keypress.enter="search"
                />
                <vs-icon icon="search"></vs-icon>
              </div>
              <!-- <vs-button
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-filter"
                class="mx-2 mt-4"
                radius
                @click="openFilter"
              ></vs-button> -->
           </vs-col>            
        </vs-row>  
      </template>
      <template slot="thead">
        <th-sort
          :text="$t('no_part') | capitalize"
          column="invoices.no_parte"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$tc('description') | capitalize"
        />
        <th-sort
          :text="$tc('type',1) | capitalize"
          column="t.type"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('original') | capitalize"
          column="dwh_discrepancies.original"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('correct') | capitalize"
          column="dwh_discrepancies.correct"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('reviewer') | capitalize"
          column="reviewer.name"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$tc('review_order',1) | capitalize"
          column="ro.no_order"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$tc('entry') | capitalize"
          column="entries.entry_id"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$tc('supplier') | capitalize"
          column="v.VendorName"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$tc('date') | capitalize"
          column="dwh_discrepancies.created_at"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$tc('capturist') | capitalize"
          column="capturista.name"
          @sort="handleClickSort"
        />
       <!--  <th class="qb-sticky">
          {{ $t('actions') }}
        </th> -->
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(tr, i) in data">
          <vs-td>
            
            {{ data[i].no_parte }}
          </vs-td>
           <vs-td>
            {{ data[i].description }}
          </vs-td>
          <vs-td>
            {{ data[i].type_name }}
          </vs-td>
          <vs-td>
            {{data[i].original}}
          </vs-td>
          <vs-td>
            {{data[i].correct}}
          </vs-td>
          <vs-td>
            {{ data[i].reviewed_by_name }}
          </vs-td>
          <vs-td>
            {{ data[i].no_order }}
          </vs-td>
          <vs-td>
            {{ data[i].entry_id }}
          </vs-td>
          <vs-td>
            {{ data[i].vendor_name }}
          </vs-td>
          <vs-td>
            {{ formatDate(data[i].created_at)	 }}
          </vs-td>
          <vs-td>
            {{ data[i].capturist }}
          </vs-td>
          <!-- <vs-td>
            <div>
              <action-icon icon="ArrowRightCircleIcon" :tooltip="$t('details')" @click="showDetails(data[i].id)"/>
            </div>
          </vs-td> -->
        </vs-tr>
        <vs-tr>
          <vs-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ThSort from '@/views/components/ThSort'
import mixins from '@/mixins'
import AddButton from '@/views/components/buttons/AddButton'
export default {
  components: {
    ActionIcon,
    ThSort,
    AddButton,
  },
  data: () => ({
    text: '',
  }),
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search() {
      this.$emit('search', this.text)
    },
    handleClickSort(e) {
      this.$emit('sort', e)
    },
    add(e) {
      this.$emit('add', e)
    },
    openFilter() {
      this.$store.dispatch('toggleSidebar', 'review-order-filter')
    },
    showDetails(id) {
      this.$router.push({
        name: 'load-order-details',
        params: {
          id: id,
        },
      })
    },
    printJSONflied(json_text,column){
      let json = JSON.parse(json_text)
      return json[column]
    },
    printTest(log){
      console.log(log)
    }
    
  },
  mixins: [mixins],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
</style>